<template>
	<div v-if="loginMember !== null">
		<div class="tab-title-box">
			<nav-link class="title" :class="type === 'notice' ? 'select' : ''" :url="'/board/notice'">공지사항</nav-link>
			<nav-link class="title" :class="type === 'data' ? 'select' : ''" :url="'/board/data'">자료실</nav-link>
		</div>
		<div class="search-bar web-hide">
			<input placeholder="검색" v-model="keyword" v-on:keyup.enter="searchKeyword" />
		</div>
		<Detail v-if="idx" :type="type" :idx="idx" />
		<List v-else :type="type" />
	</div>
</template>

<script>
import CONST from '@/constants';
import imgPin from '../../assets/images/icon/icon-pin@2x.png';
import List from '@/components/board/List';
import Detail from '@/components/board/Detail';
import eventBus from '@/plugins/event-bus';

export default {
	title: '게시판 메인',
	name: 'BoardMain',
	components: { List: List, Detail: Detail },
	props: ['type', 'idx'],
	data: function() {
		return {
			loginMember: null,
			imgPin: imgPin,
			select: 1,
			boardType: '',
			keyword: '',
		};
	},
	watch: {
		// type: function() {
		// 	this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.type === 'notice' ? 'HOME_NOTICE' : 'HOME_PDS');
		// },
	},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.type === 'notice' ? 'HOME_NOTICE' : 'HOME_PDS');
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
	},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		searchKeyword: function() {
			// if (this.keyword === '') {
			// 	alert('검색어를 입력해 주세요.');
			// 	return false;
			// }
			eventBus.$emit('LOAD_BOARD_DATA', this.keyword);
		},
	},
};
</script>

<style scoped></style>
